import React, { useState, useEffect } from 'react';
import { FiPhoneCall, FiMail, FiMenu, FiX } from 'react-icons/fi';
import logo from './img/flogo.png';

function Topbar() {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleNav = () => {
    setNav(!nav);
  };

  const handleNavItemClick = () => {
    setNav(false);
  };

  const handleCallClick = () => {
    window.open('tel:0743076376', '_self');
  };

  const handleMailClick = () => {
    window.open('mailto:torchbearer@gmail.com', '_self');
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative z-50">
      {/* Top Contact Bar */}
      <div 
        className={`transition-all duration-500 ${
          scrolled ? 'shadow-2xl' : ''
        }`}
        style={{
          background: scrolled 
            ? `linear-gradient(135deg, #1A1A2E 0%, #5A222B 100%)` 
            : '#ffffff'
        }}
      >
        <div className="flex px-6 md:px-10 py-3 justify-between items-center max-w-7xl mx-auto">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              className="h-10 md:h-14 w-auto transition-all duration-300" 
              src={logo} 
              alt="Torchbearer Technologies Logo" 
            />
          </div>

          {/* Desktop Contact Info */}
          <div className="hidden lg:flex items-center space-x-6">
            <div 
              className="flex items-center space-x-3 group cursor-pointer transition-all duration-300"
              onClick={handleCallClick}
            >
              <div 
                className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110"
                style={{ background: '#712B35' }}
              >
                <FiPhoneCall size={14} className="text-white" />
              </div>
              <div>
                <p className={`text-xs font-medium transition-colors duration-300 ${
                  scrolled ? 'text-gray-300' : 'text-gray-500'
                }`}>
                  Call Us
                </p>
                <p className={`text-sm font-semibold transition-colors duration-300 ${
                  scrolled ? 'text-white' : 'text-gray-900'
                }`}>
                  +254 743 076376
                </p>
              </div>
            </div>
            
            <div 
              className="flex items-center space-x-3 group cursor-pointer transition-all duration-300"
              onClick={handleMailClick}
            >
              <div 
                className="w-9 h-9 rounded-full flex items-center justify-center transition-all duration-300 group-hover:scale-110"
                style={{ background: '#712B35' }}
              >
                <FiMail size={14} className="text-white" />
              </div>
              <div>
                <p className={`text-xs font-medium transition-colors duration-300 ${
                  scrolled ? 'text-gray-300' : 'text-gray-500'
                }`}>
                  Mail Us
                </p>
                <p className={`text-sm font-semibold transition-colors duration-300 ${
                  scrolled ? 'text-white' : 'text-gray-900'
                }`}>
                  info@torchbearer.co.ke
                </p>
              </div>
            </div>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={handleNav}
            className={`block lg:hidden p-2.5 rounded-xl transition-all duration-300 ${
              scrolled ? 'text-white hover:bg-white/10' : 'text-gray-800 hover:bg-gray-100'
            }`}
            aria-label="Toggle navigation menu"
          >
            {nav ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      <div
        className={`fixed inset-0 z-50 lg:hidden transition-all duration-300 ease-in-out ${
          nav ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div
          className={`absolute inset-0 bg-black transition-opacity duration-300 ${
            nav ? 'bg-opacity-60' : 'bg-opacity-0'
          }`}
          onClick={handleNav}
        />
        
        <div
          className={`absolute right-0 top-0 h-full w-80 max-w-[85vw] bg-white shadow-2xl transform transition-transform duration-300 ease-in-out ${
            nav ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div 
            className="flex items-center justify-between p-6"
            style={{ background: 'linear-gradient(135deg, #712B35 0%, #1A1A2E 100%)' }}
          >
            <img className="h-8 w-auto" src={logo} alt="Torchbearer Technologies" />
            <button
              onClick={handleNav}
              className="p-2 rounded-lg hover:bg-white/10 transition-all duration-200"
              aria-label="Close menu"
            >
              <FiX size={20} className="text-white" />
            </button>
          </div>

          <nav className="py-4">
            <ul className="space-y-1">
              {[
                { href: '/', label: 'Home' },
                { href: '/about', label: 'About Us' },
                { href: '/projects', label: 'Projects' },
                { href: '/service', label: 'Services' },
                { href: '/contact', label: 'Contact' }
              ].map((item, index) => (
                <li key={index}>
                  <a
                    href={item.href}
                    onClick={handleNavItemClick}
                    className="flex items-center px-6 py-3.5 text-gray-700 hover:text-white transition-all duration-300 font-medium group relative overflow-hidden"
                    onMouseEnter={(e) => {
                      e.target.style.background = '#712B35';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'transparent';
                    }}
                  >
                    <span className="group-hover:translate-x-2 transition-transform duration-300 text-sm">
                      {item.label}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="border-t border-gray-200 p-6 space-y-3">
            <div 
              className="flex items-center space-x-3 p-3 rounded-xl hover:bg-gray-50 transition-all duration-300 cursor-pointer group"
              onClick={handleCallClick}
            >
              <div className="w-10 h-10 rounded-full flex items-center justify-center"
                style={{ background: '#712B35' }}>
                <FiPhoneCall size={16} className="text-white" />
              </div>
              <div>
                <p className="text-xs text-gray-500">Call Us</p>
                <p className="text-sm font-semibold text-gray-900">+254 743 076376</p>
              </div>
            </div>
            
            <div 
              className="flex items-center space-x-3 p-3 rounded-xl hover:bg-gray-50 transition-all duration-300 cursor-pointer group"
              onClick={handleMailClick}
            >
              <div className="w-10 h-10 rounded-full flex items-center justify-center"
                style={{ background: '#712B35' }}>
                <FiMail size={16} className="text-white" />
              </div>
              <div>
                <p className="text-xs text-gray-500">Email</p>
                <p className="text-sm font-semibold text-gray-900">info@torchbearer.co.ke</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Topbar;
